import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import BackImage from 'components/BackImage';
import ContentHeader from 'components/ContentHeader';
import ShowcaseCollection from 'components/ShowcaseCollection';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class ShowcaseCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: {},
      language: 'en',
    };
  }

  UNSAFE_componentWillMount() {
    this.getStandsAndFloor();
  }

  async getStandsAndFloor() {
    // App ID hardcoded until all are set in backend
    const appId = await DataHandler.matchAppId();
    let lang = await StorageHandler.load(storageKeys.lang);
    
    // Ensure we have a valid language object
    if (!lang || !lang.langFile) {
      lang = { langFile: 'en' };
    }
    
    this.setState({ language: lang.langFile });

    const params = new URLSearchParams(window.location.search);
    if (params.get('lang')) {
      let urlLang = params.get('lang');
      if (urlLang === 'es-419') {
        urlLang = 'es';
      }

      this.setState({ language: urlLang });
      lang = { langFile: urlLang };
    }

    const exhbitions = await APIHandler.getExhibitionStands(appId);
    exhbitions.forEach((stand) => {
      this.getItemsPerCategory(stand.tiles, stand.title, lang);
    });
 
  }

  async getItemsPerCategory(stands, category, lang) {
    let ids = '';
    stands.forEach((stand) => {
      ids += `&ids[]=${stand.company_id}`;
    });

    const {stands: items} = this.state;
    // Ensure lang is a string, not an object
    const langCode = typeof lang === 'object' ? lang.langFile : lang;
    const allStands = await APIHandler.getStands(ids, langCode);
    items[category] = allStands.items;
    this.setState({ stands: items });

    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'guest';
      if (userObj && userObj.response) {
        ({ email } = userObj.response);
      }
      APIHandler.trackSearch(ids, email);
    });
  }

  render() {
    const { stands, language } = this.state;
    const params = new URLSearchParams(window.location.search);
    if (stands.length === 0) {
      return <div />;
    }

    // Ensure i18n is properly initialized with English
    const headerText = i18n.translate('nav.showcases') || 'Partner Showcases';

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage darken/>
        <div className="showcaseContainer">
          <ContentHeader header={headerText} icon="" line={false} />
          <div className="showcaseCountriesGrid">
            {Object.entries(stands).map(([key, stand]) => (
              <ShowcaseCollection stands={stand} category={key} key={key} language={language || 'en'} />
            ))}
            <style>{'\
            .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; }'}</style>
            {params.get('mobile') && (
              <style>
                {
                  `\
                  .cookieConsent { display: none !important; } .header { display: none !important; } 
                  .showcaseContainer { margin-top: 3rem !important; } nav { display: none !important; }
                  `
                }
              </style>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionView.defaultProps = {
  // headerSubtitle: '',
};
